/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_TipsInputs */

const en_directory_ai_tools_eyebrow_tips = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo tips`)
};

const zh_directory_ai_tools_eyebrow_tips = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照片建议`)
};

/**
* | output |
* | --- |
* | "Photo tips" |
*
* @param {Directory_Ai_Tools_Eyebrow_TipsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_tips = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_TipsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_TipsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_tips(inputs)
	return zh_directory_ai_tools_eyebrow_tips(inputs)
});
export { directory_ai_tools_eyebrow_tips as "directory.ai_tools.eyebrow.tips" }